/* eslint-disable import/prefer-default-export */
export const handleNativeAction = (type, data) => {
  console.log(JSON.stringify({
    type: type,
    ...data
  }));
  if (window.ReactNativeWebView) {
    window?.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: type,
        ...data
      })
    );
  }
};
